import { combineReducers } from "redux"
import facilityReducer from "./facilityReducer"
import locationReducer from "./locationReducer"
import driverReducer from "./driverReducer"
import visitReducer from "./visitReducer"
import appointmentReducer from "./appointmentReducer"
import fileReducer from "./fileReducer"
import edocsReducer from "./edocsReducer"
import directionReducer from "./directionReducer"
import visitSummaryReducer from "./visitSummaryReducer"
import assetReducer from "./gateLinkReducer"
import carrierSearchReducer from "./carrierSearchReducer"
import { RESET_STORE } from "../actions/types"
import languageReducer from "locale/languageState"
import loadDetailsReducer from "./loadDetailsReducer"

const appReducer = combineReducers({
  locationReducer,
  facilityReducer,
  driverReducer,
  visitReducer,
  appointmentReducer,
  fileReducer,
  edocsReducer,
  visitSummaryReducer,
  directionReducer,
  assetReducer,
  carrierSearchReducer,
  languageReducer,
  loadDetailsReducer
})

// reset the state of a redux store
const rootReducer = (state: any, action: any) => {
  if (action.type === RESET_STORE) {
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer
